import { render } from "./ProjectContextModalEmpty.vue?vue&type=template&id=4d6e1d1f"
import script from "./ProjectContextModalEmpty.vue?vue&type=script&lang=js"
export * from "./ProjectContextModalEmpty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__